"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var moment = require("moment");
var classNames = require("classnames");
var components_1 = require("components");
var avatars_1 = require("components/Avatar/avatars");
var ReliablePartnerStatus_1 = require("components/ReliablePartnerStatus");
var react_redux_1 = require("react-redux");
var ListRow = React.memo(function (_a) {
    var _b;
    var index = _a.index, data = _a.data, style = _a.style;
    var items = data.items, selectedLanguage = data.selectedLanguage, selected = data.selected, toggleSelect = data.toggleSelect, currentBriefcase = data.currentBriefcase, currentBid = data.currentBid;
    var row = items[index];
    var isSelected = selected.filter(function (x) { return x.user.uuid === items[index].user.uuid; }).length > 0
        ? 'selected'
        : null;
    var user = row.user;
    var reliablePartnerStatus = (0, react_redux_1.useSelector)(function (state) { return state.bid.tender.reliablePartnerStatusCheck; });
    var _c = React.useState((_b = row.reliablePartnerStatus) === null || _b === void 0 ? void 0 : _b.value), reliablePartnerStatusValue = _c[0], setReliablePartnerStatusValue = _c[1];
    React.useEffect(function () {
        var _a;
        reliablePartnerStatus.participantUuid === row.user.uuid &&
            reliablePartnerStatus.value !== 'UNKNOWN'
            ? setReliablePartnerStatusValue(reliablePartnerStatus.value)
            : setReliablePartnerStatusValue((_a = row.reliablePartnerStatus) === null || _a === void 0 ? void 0 : _a.value);
    }, [reliablePartnerStatus, row]);
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { circle: true, className: isSelected, icon: 'fa-check', onClick: function () { return toggleSelect(!isSelected, row); } })),
        React.createElement("div", { className: 'row__column mobile avatar' },
            React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(row.user.avatar) })),
        React.createElement("div", { className: 'row__column dynamic mobile __name' }, user.disabled ? (React.createElement("del", null,
            React.createElement(react_router_dom_1.Link, { className: 'info', to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(currentBid.id, "/participants/").concat(user.id) },
                React.createElement("div", { className: 'name' },
                    user.firstName,
                    " ",
                    user.lastName),
                React.createElement("div", null, user.email)))) : (React.createElement(react_router_dom_1.Link, { className: 'info', to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(currentBid.id, "/participants/").concat(user.id) },
            React.createElement("div", { className: 'name' },
                user.firstName,
                " ",
                user.lastName),
            React.createElement("div", null, user.email)))),
        React.createElement("div", { className: 'row__column dynamic mobile __company' }, row.company),
        currentBid.procerement.reliablePartnerReport && (React.createElement("div", { className: 'row__column dynamic mobile __reliablePartnerReport' },
            React.createElement(ReliablePartnerStatus_1.ReliablePartnerStatus, { status: reliablePartnerStatusValue, text: (0, ReliablePartnerStatus_1.reliablePartnerStatusText)(reliablePartnerStatusValue) }))),
        React.createElement("div", { className: 'row__column dynamic mobile __offerSubmitted' }, row.offerSubmitted && displayDate(row.offerSubmitted)),
        React.createElement("div", { className: "row__column narrow" })));
});
var displayDate = function (dateInput) {
    if (!dateInput)
        return '-';
    return moment(dateInput).format('L LT');
};
exports.default = ListRow;
